import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const Title = ({
  cdMissionListLength = 0,
  setCdMissionList = () => {},
  setAddOrRemoveModal = () => {},
  translate = () => {},
}) => {
  const renderOptions = () => {
    const list = [
      { label: 'add.remove', action: () => setAddOrRemoveModal(true) },
      { label: 'cancel', action: () => setCdMissionList([]) },
    ]

    return list.map(({ label, action }) => (
      <Fragment key={label}>
        {' '}
        |{' '}
        <span onClick={action} style={{ color: '#72BF44', cursor: 'pointer' }}>
          {translate(`stockTransfer.missionBlock.selection.${label}`)}
        </span>
      </Fragment>
    ))
  }

  return (
    <div className='mission-block-action-mode'

    >
      {cdMissionListLength > 0 && (
        <div style={{ marginTop: '1rem' }}>
          <strong>{`${cdMissionListLength} ${translate(
            `stockTransfer.missionBlock.selection.quantity${
              cdMissionListLength > 1 ? 'Plural' : 'Singular'
            }`
          )}`}</strong>
          {renderOptions()}
        </div>
      ) }
    </div>
  )
}

Title.propTypes = {
  cdMissionListLength: PropTypes.number.isRequired,
  handleSideFilterMenuCollapseChange: PropTypes.func.isRequired,
  setCdMissionList: PropTypes.func.isRequired,
  sideFilterVisible: PropTypes.bool.isRequired,
  translate: PropTypes.func.isRequired,
  setAddOrRemoveModal: PropTypes.func.isRequired
}

export default Title
